import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import module from "./WrapTable.module.css";
import HistoryModal from "./HistoryModal";
import { CircularProgress, TablePagination, styled } from "@mui/material";
import { useState } from "react";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';

export default function WrapTable({
  rows,
  columns = [],
  handleRowClick,
  isLoading = false,
  tab,
  page,
  setPage,
}) {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedModalStatus, setSelectedModalStatus] = useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const Cell = styled(TableCell)(() => ({
    padding: "16px 8px",
    width: "8px",
  }));

  return (
    <>
      <HistoryModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} status={selectedModalStatus} />
      <TableContainer
        component={Paper}
        className={module.root}
        sx={{ backgroundColor: "#f5f5f5", boxShadow: "none" }}
      >
        {rows.length || !isLoading ? (
          <Table
            sx={{
              width: "80%",
              margin: "auto",
              "@media (max-width: 900px)": {
                width: "90%",
                minWidth: "375px",
              },
            }}
            stickyHeader
            aria-label="sticky table"
          >
            <TableHead>
              <TableRow className={module.tr}>
                {columns.map((column) => (
                  <Cell key={`head_${column.label}`} align="center">
                    {column.label}
                  </Cell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, i) => {
                  const isClickable = row.judgeStatus >= 2 && row.judgeStatus <= 6 || row.transferredAt;

                  return (
                    <TableRow
                      key={`key_${row.date}_${tab}_${i}`}
                      onClick={() => {
                        if ((isClickable) && row.judgeStatus >= 2) {
                          setSelectedModalStatus(row.judgeStatus);
                          setIsModalOpen(true);
                        } else {
                          handleRowClick(row);
                        }
                      }}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        backgroundColor: "#fff",
                        "&:hover": {
                          backgroundColor: isClickable ? "#f5f5f5" : "#fff",
                        },
                        cursor: isClickable ? "pointer" : "default",
                      }}
                    >
                      {columns.map((column, k) => {
                        const value = row[column.key];
                        if (column.key === "transferredMoney") {
                          return <Cell key={`cell_key_${row.date}_${tab}_${i}_${k}`} align="center" sx={{ color: "#15B855", fontSize: "16px", fontWeight: "500" }}>{value.toLocaleString()}<span className={module.yenText}>円</span></Cell>;
                        }
                        if (column.key === "total") {
                          return <Cell key={`cell_key_${row.date}_${tab}_${i}_${k}`} align="center" sx={{ color: "#15B855", fontSize: "16px", fontWeight: "500", position: "relative" }}>
                              <span>{value.toLocaleString()}</span>
                              <span className={module.yenText}>円</span>
                            </Cell>
                        }
                        if (column.key === "arrow") {
                          return <Cell key={`cell_key_${row.date}_${tab}_${i}_${k}`} align="center" sx={{ width: "5%", color: "#000000" }}>
                          <ArrowCircleRightIcon />
                        </Cell>;
                        }
                        return <Cell key={`cell_key_${row.date}_${tab}_${i}_${k}`} align="center">{value}</Cell>;
                      })}
                    </TableRow>
                  )
                })}
            </TableBody>
          </Table>
        ) : (
          <CircularProgress color="success" />
        )}
      </TableContainer>
      {rows.length > 10 && (
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            width: "fit-content",
            margin: "auto",
            marginTop: "20px",

            "@media (max-width: 640px)": {
              marginTop: "10px",
            },
          }}
        />
      )}
    </>
  );
}
